import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../../config/AuthProvider/authProvider';
import { LOANS_INFO } from '../../../../../config/cacheKey';
import LayoutWithoutDrawer from '../../../../../layouts/LayoutWithoutDrawer';
import { setHeaderTitle } from '../../../../../redux/headerTitle/headerTitleSlice';
import { RootState } from '../../../../../redux/store';
import DrawerBody from '../../../../requestSteps/drawerBody/drawerBody';
import Payment from '../../../../requestSteps/inquiryFee/resultPayment/payment';
import AssignedLoans from '../assignedLoans/assignedLoans';
import FutureLoans from '../assignedLoans/futureLoans';
import CanceledLoans from '../canceldLoans/CanceledLoans';
import InstallmentPayment from '../../../../requestSteps/inquiryFee/resultPayment/installmentPayment';
import VerticalySplittedLayout from '../../../../../components/layouts/verticalySplittedLayout';
import AssignedLoanCard from '../../../../../components/card/DrawerCards/AssignedLoanCard';
import { AppBarProvider } from '../../../../../components/appBar/appBarContext';


const InstallmentsContainer = () => {
    const [state, setState] = useState<'AssignedLoans' | 'FutureLoans' | 'payment' | 'CanceledLoans' | 'installmentPayment' | 'OnlinePrePayment'>();
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as ('AssignedLoans' | 'FutureLoans' | 'payment');
    const { referenceKey, setRefKey } = useAuth();
    const dispatch = useDispatch();
    const queryClient: any = useQueryClient()
    const loanRequestStatus = queryClient.getQueryData(LOANS_INFO)

    const headerConfig: Record<string, { color: string, header: string }> = {
        'Assigned': { color: "var(--bg-loan-card)", header: "اطلاعات اقساط" },
        'CanceledBySetad': { color: "var(--bg-loan-card)", header: "لغو شده توسط کارشناس" },
        'default': { color: "var(--bg-loan-card)", header: "پرداخت اقساط" }
    };
    const myUrl = queryClient.getQueryData("URL_PARAMS") as any

    useEffect(() => {
        if (myUrl?.param?.includes("installmentPayment")) {
            setState('installmentPayment');
        }
        if (myUrl?.param?.includes("OnlinePrePayment")) {
            setState('OnlinePrePayment');
        }
        else if (stateFromRedux === 'AssignedLoans') {
            setState('AssignedLoans')
        } else if (stateFromRedux === 'payment') {
            setState('payment')
        } else if (stateFromRedux === 'FutureLoans') {
            setState('FutureLoans')
        } else if (stateFromRedux === 'CanceledLoans') {
            setState('CanceledLoans')
        }

        const { color, header } = headerConfig[loanRequestStatus?.loanRequestStatus] || headerConfig['default'];
        dispatch(
            setHeaderTitle({
                color,
                header,
                parentRoute: 'loans',
            })

        );

    }, [stateFromRedux])
    return (
        <>

            {state === 'AssignedLoans' &&

                <VerticalySplittedLayout top={<AssignedLoanCard />} bottom={
                    <AppBarProvider>
                        <AssignedLoans referenceKey={referenceKey!} setStep={setState} />
                    </AppBarProvider>
                } />
            }
            {state === 'payment' &&
                <LayoutWithoutDrawer >
                    <Payment referenceKey={referenceKey!} setStep={state} parentRoute='AssignedLoans' />
                </LayoutWithoutDrawer>}

            {state === 'FutureLoans' &&
                <VerticalySplittedLayout top={<AssignedLoanCard />} bottom={
                    <AppBarProvider>
                        <FutureLoans referenceKey={referenceKey!} setStep={setState} />
                    </AppBarProvider>
                } />}
            {state === "CanceledLoans" &&
                <DrawerBody isAssigned>
                    <CanceledLoans />
                </DrawerBody>
            }
            {state === "installmentPayment" &&
                <LayoutWithoutDrawer >
                    <InstallmentPayment setState={setState} referenceKey={referenceKey!} />
                </LayoutWithoutDrawer>
            }
        </>
    )
}

export default InstallmentsContainer